"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSendAuthCode = void 0;
var react_query_1 = require("@tanstack/react-query");
var api_1 = require("../../api");
var react_redux_1 = require("react-redux");
var useSendAuthCode = function () {
    var chainId = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return ({
            chainId: (_a = state.app.chain) === null || _a === void 0 ? void 0 : _a.id,
        });
    }).chainId;
    return (0, react_query_1.useMutation)(['send-auth-cod', chainId], function (_a) {
        var chain_id = _a.chain_id, phone = _a.phone;
        return (0, api_1.sendAuthCode)({
            chain_id: chain_id,
            phone: phone
        });
    });
};
exports.useSendAuthCode = useSendAuthCode;
